const composeStreamError = (existing: string, message: string): string => {
	const trimmed = existing.trim();
	if (!trimmed) return `Error: ${message}`;
	return `${trimmed}\n\n_Fernie's response was interrupted: ${message}_`;
};

export default composeStreamError;

export { composeStreamError };
